/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Hero_FindInputs */

const en_portal_hero_find = /** @type {(inputs: Portal_Hero_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a coach`)
};

const pl_portal_hero_find = /** @type {(inputs: Portal_Hero_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź trenera`)
};

/**
* | output |
* | --- |
* | "Find a coach" |
*
* @param {Portal_Hero_FindInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_hero_find = /** @type {((inputs?: Portal_Hero_FindInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Hero_FindInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_hero_find(inputs)
	return en_portal_hero_find(inputs)
});